import { ArrowRight, TrendingDown, Shield, DollarSign } from "lucide-react";
import { ContactButton } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import { HeroBackground } from "@/components/ui/hero-background";

export const CFOHeroSection = () => {
  return (
    <HeroBackground 
      pattern="grid" 
      colorScheme="purple" 
      height="min-h-[900px] md:h-[800px]"
      className="animate-fade-in"
    >
      <Container className="py-2 md:py-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Main Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight tracking-tight text-gray-900 animate-fade-up">
              Cut IT & Cybersecurity Costs{" "}
              <span className="bg-gradient-to-r from-edgefi-purple to-edgefi-amethyst bg-clip-text text-transparent">
                Without Compromising Security
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed font-light animate-fade-up" style={{ animationDelay: "0.1s" }}>
              Stop buying "new, new, new." With edgefi, CFOs gain a strategy that stretches existing IT and cybersecurity investments further—delivering cost savings while strengthening security.
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 animate-fade-up" style={{ animationDelay: "0.2s" }}>
              <ContactButton
                className="bg-edgefi-purple hover:bg-edgefi-purple/90 text-white group"
                modalTitle="CFO Strategy Session"
                modalDescription="Tell us about your current IT and cybersecurity investments. We'll show you opportunities to reduce costs while strengthening security."
                additionalFields={{
                  lead_source: "CFO Landing Page Hero",
                  lead_interest: "IT Cost Optimization",
                  target_audience: "CFO"
                }}
                variant="cta"
                size="lg"
              >
                Book CFO Strategy Session
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </ContactButton>
            </div>
          </div>

          {/* Burgerville Case Study */}
          <div className="animate-fade-up" style={{ animationDelay: "0.3s" }}>
            <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 border border-gray-100">
              {/* Company Header */}
              <div className="flex items-center mb-6 md:mb-8">
                <div className="bg-white rounded-lg p-3 mr-4 shadow-sm border border-gray-200">
                  <img 
                    src="/lovable-uploads/5d01493d-ec13-4ea7-b07e-106a31456b3e.png" 
                    alt="Burgerville logo"
                    className="h-12 w-auto object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Burgerville</h3>
                  <p className="text-gray-600">42 Restaurant Locations</p>
                </div>
              </div>

              {/* Key Metrics Grid */}
              <div className="grid grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
                <div className="text-center">
                  <div className="text-4xl font-bold text-edgefi-purple mb-2">50%</div>
                  <div className="text-lg font-semibold text-gray-900 mb-1">Security Cost Reduction</div>
                  <div className="text-sm text-gray-600">Using existing tools strategically</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-edgefi-purple mb-2">30%</div>
                  <div className="text-lg font-semibold text-gray-900 mb-1">IT Cost Reduction</div>
                  <div className="text-sm text-gray-600">Optimized current investments</div>
                </div>
              </div>
              
              {/* Quote */}
              <blockquote className="text-gray-800 font-medium text-center border-t border-gray-200 pt-6">
                "They showed us we were already paying for the solutions we needed—we just weren't using them strategically."
              </blockquote>
              <cite className="text-sm text-gray-600 mt-3 block text-center">— Director of IT, Burgerville</cite>
            </div>
          </div>
        </div>
      </Container>
    </HeroBackground>
  );
};